// extracted by mini-css-extract-plugin
module.exports = {"modal":"Faq_modal__ubBhE","notes":"Faq_notes__JZUf6","note":"Faq_note__gCHhV"};